import { render, staticRenderFns } from "./EditBuyDirect.vue?vue&type=template&id=57f6ca06"
import script from "./EditBuyDirect.vue?vue&type=script&lang=js"
export * from "./EditBuyDirect.vue?vue&type=script&lang=js"
import style0 from "./EditBuyDirect.vue?vue&type=style&index=0&id=57f6ca06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports